import axios from 'axios'
import {collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where} from "firebase/firestore";
import {auth, db} from "./firebaseApp";
import {toast} from "react-toastify";
import {enums} from "./enums";

export const getIpData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    console.log(res.data.ip);
    try {
        const ipDetails = await axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=ac9c0f52f42c4ad18160a3329030eef2&ip=${res.data.ip}&fields=geo`)
        console.log(ipDetails)
        return ipDetails
    } catch (error) {
        console.log(error);
        return null
    }
};

export async function addUpdateResponseInDb(responseObject) {
    console.log('adding', responseObject)
    try {
        const ref = doc(db, "responses", responseObject.uid);
        await updateDoc(ref, responseObject)
        console.log('success')
    } catch (e) {
        console.log(e.code === 'not-found')
        console.log(e)
        if (e.code === 'not-found') {
            try {
                console.log('setting')
                await setDoc(doc(db, "responses", responseObject.uid), responseObject)
            } catch (e) {
                console.log(e)
            }
        }
    }
}


export async function getObjectFromDb(objectUid, collection) {
    try {
        const ref = doc(db, collection, objectUid);
        const documentSnapshot = await getDoc(ref);

        //TODO remove when admin side is done
        if (!documentSnapshot.exists()) return null
        else return documentSnapshot.data()

    } catch (error) {
        console.log(error)
        if (error.response) {
            toast.error("error", "Something went wrong, please try again!")
        }
    }
}

export async function addNewPaymentCardToUser(currentUser, paymentCards, event, dispatch) {
    const paymentCard={
        uid: crypto.randomUUID(),
        balance: 0,
        eventUid: event.uid,
        eventName: event.name,
        userUid: currentUser.uid
    }

    try {
        await setDoc(doc(db, "paymentCards", paymentCard.uid), paymentCard)
        await updateDoc(doc(db, "users", currentUser.uid), {
            paymentCards: [...currentUser.paymentCards, paymentCard.uid]
        })
        const updatedCurrentUser = currentUser
        updatedCurrentUser.paymentCards = [...updatedCurrentUser.paymentCards, paymentCard.uid]

        dispatch({currentUser: currentUser})
        dispatch({paymentCards: [...paymentCards, paymentCard]})

    } catch (e) {
        console.log(e)
    }
}


export async function getPaymentCards(userUid) {
    const paymentCards = []
    const q = query(collection(db, "paymentCards"), where("userUid", "==", userUid));
    const paymentCardsSnapshot = await getDocs(q);
    paymentCardsSnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        paymentCards.push(doc.data())
    });

    return paymentCards
}

export async function hydrateUserData(dispatch, navigate, eventName, eventObject){
    const docRef = doc(db, "users", auth.currentUser.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        dispatch({currentUser: docSnap.data()})
        console.log('user set up')
        console.log(docSnap.data())
        // routeUser(docSnap.data().role, navigate)
    } else {
        console.log('no user fiund')
        // try {
        //     await setDoc(doc(db, "users", auth.currentUser.uid), {
        //         uid: auth.currentUser.uid,
        //         joined: Date.now(),
        //         images: []
        //     });
        //     dispatch({
        //         currentUser: {
        //             uid: auth.currentUser.uid,
        //             joined: Date.now(),
        //             images: []
        //         }
        //     })
        //     navigate('/dashboard')
        // } catch (e) {
        //     console.log(e)
        // }
    }
}

export function routeUser(role, navigate) {
    console.log('routing')
    switch (role) {
        case enums.VALIDATOR:
            console.log('routing')
            navigate('/ticketScanner')
            break
        default:
            navigate('/login')

    }
}


export function sumEverythingInCart(cart) {
    let total = 0
    cart.forEach(item => {
        total += item.quantity * item.price
    })

    return total
}
